const lookupReducer = (state = {}, action) => {
    switch (action.type) {
        case "getShipTypeListSuccess":
            return Object.assign({}, state, {
                shipType: action.data,
            });
            break;

        case "getSubCategoryListSuccess":
            return Object.assign({}, state, {
                subCategory: action.data,
            });
            break;
            
        case "getStatusListSuccess":
            return Object.assign({}, state, {
                statusType: action.data,
            });
            break;
            case "getInspectionTypeListSuccess":
                return Object.assign({}, state, {
                    inspectionType: action.data,
                });
                break;
     
        default: {
            return state;
        }
    }
};
export default lookupReducer;
